import {
  integrationLabel,
  integrationRegistry,
} from "@p0security/shared/integrations/registry";
import type { BundleItem } from "@p0security/shared/types/bundle";
import { Flex, Image, Spacing, Tag, Tooltip, Typography } from "@p0security/ui";
import { isKeyOf } from "@p0security/util/types/is";
import { startCase } from "lodash";

export const bundleItemLabel = (item: BundleItem): string => {
  const argParts = Object.entries(item.args)
    .filter(([, value]) => value !== undefined && value !== "")
    .map(([key, value]) => {
      const values = Array.isArray(value) ? value.map(String) : [String(value)];
      return `${startCase(key)}: ${values.join(", ")}`;
    });
  return argParts.length ? argParts.join(" / ") : item.type;
};

export const BundleItemDisplay: React.FC<{ item: BundleItem }> = ({ item }) => {
  const label = bundleItemLabel(item);
  return (
    isKeyOf(integrationRegistry, item.type) && (
      <Flex vertical gap={2} className="min-w-0">
        <Flex align="center" gap={8}>
          <Image
            src={integrationRegistry[item.type].logoUrl}
            alt={item.type}
            width={16}
            preview={false}
            className="shrink-0"
          />
          <Typography.Text strong>
            {integrationLabel(item.type)}
          </Typography.Text>
          <Spacing asChild m={0}>
            <Tag>{startCase(item.access)}</Tag>
          </Spacing>
        </Flex>
        <Tooltip title={label}>
          <Typography.Text type="secondary" ellipsis className="pl-6">
            {label}
          </Typography.Text>
        </Tooltip>
      </Flex>
    )
  );
};
